<glxy-page>
  <glxy-page-toolbar>
    <glxy-page-title>
      {{ 'INTEGRATIONS.IDENTITY_PROVIDER.PAGE_TITLE' | translate }}
    </glxy-page-title>
    <glxy-page-nav>
      <glxy-page-nav-button
        [previousPageTitle]="'ADMINISTRATION.PAGE_TITLE' | translate"
        [previousPageUrl]="'/settings'"
        [useHistory]="true"
        [historyBackButtonTitle]="'COMMON.ACTION_LABELS.BACK' | translate"
      ></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-actions>
      <button mat-raised-button (click)="openDeleteDialog()">
        {{ 'INTEGRATIONS.IDENTITY_PROVIDER.DELETE' | translate }}
      </button>
    </glxy-page-actions>
  </glxy-page-toolbar>
  <glxy-page-wrapper [widthPreset]="'wide'">
    <mat-card appearance="outlined" class="panel loading" *ngIf="loading$ | async">
      <mat-spinner [diameter]="50"></mat-spinner>
    </mat-card>
    <mat-card appearance="outlined" class="panel" *ngIf="(loading$ | async) === false && (error$ | async)">
      {{ 'INTEGRATIONS.IDENTITY_PROVIDER.SOMETHING_WENT_WRONG' | translate }}
    </mat-card>
    <ng-container *ngIf="(loading$ | async) === false && (error$ | async) === false">
      <mat-expansion-panel class="guide" expanded>
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'INTEGRATIONS.IDENTITY_PROVIDER.SSO_CONFIGURATION_GUIDE' | translate }}
          </mat-panel-title>
          <mat-panel-description>
            {{ 'INTEGRATIONS.IDENTITY_PROVIDER.DETAILED_SETUP_INSTRUCTIONS' | translate }}
          </mat-panel-description>
        </mat-expansion-panel-header>
        <p>
          {{ 'INTEGRATIONS.IDENTITY_PROVIDER.CONFIGURE_YOUR_IDENTITY_PROVIDER' | translate }}
        </p>
        <p>
          {{ 'INTEGRATIONS.IDENTITY_PROVIDER.SUPPORTED_AUTH_FLOWS' | translate }}
        </p>
        <ol>
          <li [innerHtml]="'INTEGRATIONS.IDENTITY_PROVIDER.STEP_ONE' | translate: { redirectUri: redirectUri }"></li>
          <li [innerHtml]="'INTEGRATIONS.IDENTITY_PROVIDER.STEP_TWO' | translate"></li>
          <li [innerHtml]="'INTEGRATIONS.IDENTITY_PROVIDER.STEP_THREE' | translate"></li>
          <li [innerHtml]="'INTEGRATIONS.IDENTITY_PROVIDER.STEP_FOUR' | translate"></li>
          <li [innerHtml]="'INTEGRATIONS.IDENTITY_PROVIDER.STEP_FIVE' | translate"></li>
        </ol>
      </mat-expansion-panel>
      <br />
      <mat-expansion-panel class="guide">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <mat-icon svgIcon="galaxy-ai-icon" />
            <p>&nbsp;</p>
            {{ 'INTEGRATIONS.SSO_INTEGRATION.ASK_VENDASTA_SSO' | translate }}
            <p>&nbsp;</p>
            <glxy-badge [color]="'blue-solid'">Beta</glxy-badge>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-card appearance="outlined" class="panel">
          <app-sso-ai-chat></app-sso-ai-chat>
        </mat-card>
      </mat-expansion-panel>
      <br />
      <br />

      <mat-card appearance="outlined" class="panel">
        <mat-card-header>
          <mat-card-title>{{ 'INTEGRATIONS.IDENTITY_PROVIDER.REDIRECT_URI' | translate }}</mat-card-title>
          <mat-card-subtitle>{{ 'INTEGRATIONS.IDENTITY_PROVIDER.URI_MUST_BE_ADDED' | translate }}</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="redirect-uri">
            <app-clipboard>{{ redirectUri }}</app-clipboard>
          </div>
          <form [formGroup]="form" (ngSubmit)="onSubmit()" class="sso-integration-config">
            <mat-form-field>
              <mat-label>
                {{ 'INTEGRATIONS.IDENTITY_PROVIDER.OAUTH2_CLIENT_ID' | translate }}
              </mat-label>
              <input matInput required formControlName="clientId" />
            </mat-form-field>

            <mat-form-field class="with-hint">
              <mat-label>{{ 'INTEGRATIONS.IDENTITY_PROVIDER.OAUTH2_CLIENT_SECRET' | translate }}</mat-label>
              <input matInput [required]="(existingConfig$ | async) === null" formControlName="clientSecret" />
              <mat-hint *ngIf="existingConfig$ | async">
                {{ 'INTEGRATIONS.IDENTITY_PROVIDER.LEAVE_BLANK' | translate }}
              </mat-hint>
            </mat-form-field>

            <mat-form-field>
              <mat-label>
                {{ 'INTEGRATIONS.IDENTITY_PROVIDER.INTEGRATION_TYPE' | translate }}
              </mat-label>
              <select required matNativeControl formControlName="integrationType" required>
                <option value="openid">
                  {{ 'INTEGRATIONS.IDENTITY_PROVIDER.OPEN_ID_CONNECT_DISCOVERY' | translate }}
                </option>
                <option value="oauth2">
                  {{ 'INTEGRATIONS.IDENTITY_PROVIDER.OAUTH2' | translate }}
                </option>
              </select>
            </mat-form-field>

            <ng-container [ngSwitch]="form.get('integrationType').value">
              <ng-container formGroupName="openid" *ngSwitchCase="'openid'">
                <mat-form-field>
                  <mat-label>
                    {{ 'INTEGRATIONS.IDENTITY_PROVIDER.OPEN_ID_CONNECT_DISCOVERY_ENDPOINT' | translate }}
                  </mat-label>
                  <input matInput required type="url" [pattern]="urlPattern" formControlName="discoveryEndpoint" />
                </mat-form-field>
              </ng-container>

              <ng-container formGroupName="oauth2" *ngSwitchCase="'oauth2'">
                <mat-form-field>
                  <mat-label>
                    {{ 'INTEGRATIONS.IDENTITY_PROVIDER.OAUTH2_AUTH_ENDPOINT' | translate }}
                  </mat-label>
                  <input matInput required type="url" [pattern]="urlPattern" formControlName="authorizationEndpoint" />
                </mat-form-field>
                <mat-form-field>
                  <mat-label>
                    {{ 'INTEGRATIONS.IDENTITY_PROVIDER.OAUTH2_TOKEN_ENDPOINT' | translate }}
                  </mat-label>
                  <input
                    matInput
                    required
                    type="url"
                    [pattern]="urlPattern"
                    [placeholder]="'INTEGRATIONS.IDENTITY_PROVIDER.TOKEN_ENDPOINT' | translate"
                    formControlName="tokenEndpoint"
                  />
                </mat-form-field>
                <mat-form-field>
                  <mat-label>
                    {{ 'INTEGRATIONS.IDENTITY_PROVIDER.OAUTH2_USERINFO_ENDPOINT' | translate }}
                  </mat-label>
                  <input matInput required type="url" [pattern]="urlPattern" formControlName="userinfoEndpoint" />
                </mat-form-field>
              </ng-container>
            </ng-container>
            <button mat-flat-button color="primary" type="submit" [disabled]="saving$ | async">
              {{
                ((existingConfig$ | async) ? 'COMMON.ACTION_LABELS.SAVE' : 'COMMON.ACTION_LABELS.CREATE') | translate
              }}
            </button>
          </form>
        </mat-card-content>
      </mat-card>
    </ng-container>
  </glxy-page-wrapper>
</glxy-page>
